import { Navigate, Route, Routes } from 'react-router-dom';

import { PERMISSION } from 'src/features/auth';
import AllDevicesTable from 'src/features/payStations/components/AllDevicesTable';
import AllHeartBeatsTable from 'src/features/payStations/components/AllHeartBeatsTable';
import AllLogsTable from 'src/features/payStations/components/AllLogsTable';
import { Information } from 'src/features/payStations/components/Information';
import PayStationHeartBeatsTable from 'src/features/payStations/components/PayStationHeartBeatsTable';
import PayStationLogsTable from 'src/features/payStations/components/PayStationLogsTable';
import PayStationsLayout from 'src/features/payStations/components/PayStationsLayout';
import SinglePayStationLayout from 'src/features/payStations/components/SinglePayStationLayout';
import useHasPermissions from 'src/hooks/useHasPermissions';

export const PayStationRoutes = () => {
    const permissionMonitoring = useHasPermissions([PERMISSION.MONITORING]);

    return permissionMonitoring ? (
        <Routes>
            <Route path=":payStationId" element={<SinglePayStationLayout />}>
                <Route path="" element={<Information />} />
                <Route path="logs" element={<PayStationLogsTable />} />
                <Route path="heart-beats" element={<PayStationHeartBeatsTable />} />
            </Route>
            <Route path="" element={<PayStationsLayout />}>
                <Route path="" element={<AllDevicesTable />} />
                <Route path="all-logs" element={<AllLogsTable />} />
                <Route path="all-heart-beats" element={<AllHeartBeatsTable />} />
                <Route path="*" element={<Navigate to=".." />} />
            </Route>
        </Routes>
    ) : (
        <Navigate to=".." />
    );
};

export default PayStationRoutes;
